"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Keys_less_1 = __importDefault(require("./Keys.less"));
var Keys = function (_a) {
    var keys = _a.keys;
    var t = (0, react_i18next_1.useTranslation)().t;
    var keyLabelMap = (0, react_1.useMemo)(function () { return ({
        'Shift': "\u21E7 ".concat(t('SETTINGS_SHORTCUT_SHIFT')),
        'Space': t('SETTINGS_SHORTCUT_SPACE'),
        'Ctrl': t('SETTINGS_SHORTCUT_CTRL'),
        'Escape': t('SETTINGS_SHORTCUT_ESC'),
        'Backspace': t('SETTINGS_SHORTCUT_BACKSPACE'),
        'ArrowUp': '↑',
        'ArrowDown': '↓',
        'ArrowLeft': '←',
        'ArrowRight': '→',
    }); }, [t]);
    var isRange = (0, react_1.useMemo)(function () {
        return keys.length > 1 && keys.every(function (key) { return !Number.isNaN(parseInt(key)); });
    }, [keys]);
    var filteredKeys = (0, react_1.useMemo)(function () {
        return isRange ? [keys[0], keys[keys.length - 1]] : keys;
    }, [keys, isRange]);
    return (filteredKeys.map(function (key, index) {
        var _a;
        return (react_1.default.createElement(react_1.Fragment, { key: key },
            react_1.default.createElement("kbd", null, (_a = keyLabelMap[key]) !== null && _a !== void 0 ? _a : key.toUpperCase()),
            index < (filteredKeys.length - 1) && (react_1.default.createElement("div", { className: Keys_less_1.default['separator'] }, isRange ? t('SETTINGS_SHORTCUT_TO') : '+'))));
    }));
};
exports.default = Keys;
